export default {
  GA: 'google-analytics',
  GSQ: 'gsq',
};
